export class BreederInfoReward {
  public rewardId: number;
  public description: string;
  public points: number;
  public claimed: boolean;

  constructor() {
  }
}
